export const GET_ALL_SUBJECT_GROUPS = 'GET_ALL_SUBJECT_GROUPS'
export const GET_SUBJECT_GROUP_SINGLE = 'GET_SUBJECT_GROUP_SINGLE'
export const ADD_SUBJECT_GROUP = 'ADD_SUBJECT_GROUP'
export const EDIT_SUBJECT_GROUP = 'EDIT_SUBJECT_GROUP'
export const DELETE_SUBJECT_GROUP = 'DELETE_SUBJECT_GROUP'
